export { default as reducer } from "./makeModelInfo.ducks";



// WEBPACK FOOTER //
// ./src/routes/MakeModelInfo/index.ts